import PortfolioVideoModalContainer from "../../../../components/pages/portfolio/portfolioPage/PortfolioVideoModal";

const PortfolioVideoModal = () => {
  return <PortfolioVideoModalContainer />;
};

export default PortfolioVideoModal;
